import Former from "../classes/Former";

class EmployeesBlock extends Former {

    blockHideableElementSelector = '.employee-item';

    elementDataSearchableTypes = {
        text: 'employee-searchable',
        type: 'employee',
    }

    processForm(event: SubmitEvent): any {
        const parentProcess = super.processForm(event);
        const employeesHeadingContainer = document.querySelector('#employees-heading-container');
        /**
         * Always clear the heading container when filter is run
         */
        employeesHeadingContainer.innerHTML = '';


        const selectors = this.generateSelectors({
            country: parentProcess.formDataObject?.country,
            "business-unit": parentProcess.formDataObject['business-unit']
        }, {
            "text-search": parentProcess.formDataObject["text-search"]
        })

        if (parentProcess.formDataObject['business-unit']) {
            const businessUnit = document.querySelector('select[name="business-unit"]') as HTMLSelectElement;

            if (businessUnit && businessUnit.selectedIndex > 0) {

                /**
                 * Creating h2 element for heading dynamically
                 */
                const heading = document.createElement('h2');
                heading.textContent = businessUnit.options[businessUnit.selectedIndex].text; // we need to use label on option because the value is lowercased
                employeesHeadingContainer.append(heading);
            }
        }

        this.toggleItems(selectors);
    }
}

export default EmployeesBlock;